<router-outlet></router-outlet>

<div class="container">
    <footer>
        <span>
            <a href="https://www.kirche-grossrueckerswalde.de/index.php/impressum" target="_blank">Impressum</a> |
            <a href="https://www.kirche-grossrueckerswalde.de/index.php/datenschutz" target="_blank">Datenschutz</a>
        </span>
        <span>Webapp by <a href="https://www.jonashermann.de/" target="_blank">Jonas Hermann</a></span>
    </footer>
</div>